import { adjustTopValue } from 'chameleon/packages/blue-book-player/Annotation/utils/adjustTopValue';
import { getMaxHeightIncludingChildren } from 'chameleon/packages/blue-book-player/Annotation/utils/getMaxHeightIncludingChildren';

export const constrainVerticalWithinContainer = (
  container,
  boundingContainer,
) => {
  if (!container || !boundingContainer) {
    return;
  }

  const containerTop = parseFloat(container.style.top);
  const containerMaxHeight = getMaxHeightIncludingChildren(container);
  const boundingContainerScrollTop = boundingContainer.scrollTop;
  const boundingContainerHeight = boundingContainer.offsetHeight;

  if (isNaN(containerTop)) {
    return;
  }

  let adjustment = null;
  if (containerTop < boundingContainerScrollTop) {
    adjustment = boundingContainerScrollTop;
  } else if (
    containerTop + containerMaxHeight >
    boundingContainerHeight + boundingContainerScrollTop
  ) {
    adjustment =
      boundingContainerScrollTop + boundingContainerHeight - containerMaxHeight;
  }

  if (adjustment !== null) {
    adjustTopValue(container, adjustment);
  }
};
